import { render, staticRenderFns } from "./ComponentTabStats.vue?vue&type=template&id=2dd1125d&scoped=true&"
import script from "./ComponentTabStats.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentTabStats.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentTabStats.vue?vue&type=style&index=0&id=2dd1125d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1125d",
  null
  
)

export default component.exports